import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SchedaCoopAgricoleFormModule } from './scheda-coop-agricole/scheda-coop-agricole-form.module';
import { SchedaCoopAltreCoopFormModule } from './scheda-coop-altre-coop/scheda-coop-altre-coop-form.module';
import { SchedaCoopConsumoFormModule } from './scheda-coop-consumo/scheda-coop-consumo-form.module';
import { SchedaCoopDettagliantiFormModule } from './scheda-coop-dettaglianti/scheda-coop-dettaglianti-form.module';
import { SchedaCoopEdilizieFormModule } from './scheda-coop-edilizie/scheda-coop-edilizie-form.module';
import { SchedaCoopGaranziaFidiFormModule } from './scheda-coop-garanzia-fidi/scheda-coop-garanzia-fidi-form.module';
import { SchedaCoopPescaFormModule } from './scheda-coop-pesca/scheda-coop-pesca-form.module';
import { SchedaCoopProdLavoroFormModule } from './scheda-coop-prod-lavoro/scheda-coop-prod-lavoro-form.module';
import { SchedaCoopSocialiFormModule } from './scheda-coop-sociali/scheda-coop-sociali-form.module';
import { SchedaCoopTrasportoFormModule } from './scheda-coop-trasporto/scheda-coop-trasporto-form.module';
import { SchedaSettoreFormService } from './scheda-settore-form.service';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        SchedaCoopAgricoleFormModule,
        SchedaCoopAltreCoopFormModule,
        SchedaCoopConsumoFormModule,
        SchedaCoopDettagliantiFormModule,
        SchedaCoopEdilizieFormModule,
        SchedaCoopGaranziaFidiFormModule,
        SchedaCoopPescaFormModule,
        SchedaCoopProdLavoroFormModule,
        SchedaCoopSocialiFormModule,
        SchedaCoopTrasportoFormModule,
    ],
    providers: [SchedaSettoreFormService],
})
export class SchedaSettoreFormModule {}
